const weekdays = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']

const intervalLabel = (minutes) => {
  if (!Number.isFinite(minutes) || minutes <= 0) return null
  if (minutes % 10080 === 0) {
    const weeks = minutes / 10080
    return weeks === 1 ? 'Cada semana' : `Cada ${weeks} semanas`
  }
  if (minutes % 1440 === 0) {
    const days = minutes / 1440
    return days === 1 ? 'Cada día' : `Cada ${days} días`
  }
  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60)
    const rest = minutes % 60
    return `Cada ${hours === 1 ? 'hora' : `${hours} horas`}${rest ? ` y ${rest} min` : ''}`
  }
  return `Cada ${minutes} min`
}

const cronLabel = (expression) => {
  const fields = String(expression || '').trim().split(/\s+/)
  if (fields.length !== 5) return null
  const [minute, hour, day, month, weekday] = fields
  if (!/^\d{1,2}$/.test(minute) || !/^\d{1,2}$/.test(hour)) return null
  if (Number(minute) > 59 || Number(hour) > 23 || month !== '*') return null
  const time = `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`
  if (day === '*' && weekday === '*') return `Todos los días a las ${time}`
  if (day === '*' && /^[0-7]$/.test(weekday)) return `Cada ${weekdays[Number(weekday) % 7]} a las ${time}`
  if (/^\d{1,2}$/.test(day) && Number(day) >= 1 && Number(day) <= 31 && weekday === '*') {
    return `Día ${Number(day)} de cada mes a las ${time}`
  }
  return null
}

export const formatIntegrationSchedule = (schedule) => {
  if (!schedule) return 'Sin programación'
  if (schedule.scheduleType === 'INTERVAL') {
    return intervalLabel(Number(schedule.frequencyMinutes)) || 'Programada'
  }
  if (schedule.cronExpression) {
    return cronLabel(schedule.cronExpression) || `Cron: ${schedule.cronExpression}`
  }
  return schedule.scheduleType || 'Programada'
}
